import { debounce } from 'lodash-es'

const _state = {
  cachedPresentations: {},
}

const mutations = {
  setCachedPresentations(state, payload) {
    /* eslint-disable no-param-reassign */
    state.cachedPresentations[payload.id] = payload
  },

  clearPresentationDetailsCache(state, payload) {
    /* eslint-disable no-param-reassign */
    delete state.cachedPresentations[payload.id]
  },
}

/**
 * This helps prevent multiple requests are made at the same time
 * when the previous preWarm request are still pending
 */
const inFlight = new Map()

const warmCachePresentationDetails = debounce((dispatch, { presentationId, payloadDataPresentation }) => {
  dispatch('getPresentationDetailsWithCacheAction', { presentationId, payloadDataPresentation })
}, 200)

const actions = {
  getPresentationDetailsWithCacheAction: async ({ state, commit, dispatch },
    { presentationId, payloadDataPresentation }) => {
    if (state.cachedPresentations && state.cachedPresentations[presentationId]) {
      return state.cachedPresentations[presentationId]
    }
    if (inFlight.has(presentationId)) {
      return inFlight.get(presentationId)
    }
    const requestPromise = dispatch(
      'fetchPresentationDetailsFromAPIAction',
      { presentationId, payloadDataPresentation },
      { root: true },
    )
      .then((res) => {
        commit('setCachedPresentations', {
          id: presentationId,
          ...res,
        })
        return res
      })
      .finally(() => {
        inFlight.delete(presentationId)
      })

    inFlight.set(presentationId, requestPromise)

    return requestPromise
  },

  preWarmCachePresentationDetailsAction: ({ dispatch }, { presentationId, payloadDataPresentation }) => {
    warmCachePresentationDetails(dispatch, { presentationId, payloadDataPresentation })
  },

  clearPresentationDetailsCacheAction: ({ commit }, { presentationId }) => {
    commit('clearPresentationDetailsCache', { id: presentationId })
  },
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
}
